export const GOAL_INDEX_EVENT_NAMES = {
  VIEWED_PAGE: 'Viewed Learning Goal Index Page',
  TOGGLED_SUBJECT: 'Toggled LGI Subject',
  OPENED_CATEGORY_LINK: 'Opened LGI Category Link'
}
